import React, { Fragment, useEffect } from "react";

// The downloaded replays from replay-app require the dynamic sprite files to be accessed from the executable file directory.
// Therefore, window.api is used to differentiate the URL between the browser environment and the downloaded Electron replays.
const spriteURL = !window.api
	? `https://${window.location.host}/_fileDownload/map-sprites/dynamic-sprites.json`
	: "/dynamic-sprites.json";
const sprite_PNG_URL = !window.api
	? `https://${window.location.host}/_fileDownload/map-sprites/dynamic-sprites.png`
	: "/dynamic-sprites.png";

const loadSpriteJSON = async () => {
	try {
		const response = await fetch(spriteURL);
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}
		global.OC_spriteData = await response.json();
	} catch (error) {
		console.error("Error loading JSON:", error);
	}
};

const loadSpriteImage = async () => {
	try {
		const response = await fetch(sprite_PNG_URL);
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}
		const blob = await response.blob();
		const imageURL = URL.createObjectURL(blob);
		global.OC_spriteImage = new Image();
		global.OC_spriteImage.src = imageURL;
	} catch (error) {
		console.error("Error loading image:", error);
	}
};

const DynamicSpriteService = () => {
	useEffect(() => {
		loadSpriteJSON();
		loadSpriteImage();
	}, []);
	return <Fragment />;
};

export default DynamicSpriteService;
